<template>
  <div>
    <section-title content="Información General" :has-line="true" />
    <div class="rounded pt-2 pb-3 px-4">
      <div class="row">
        <div class="col-md-4">
          <label class="data-title mb-0">
            Dirección Web:
          </label>
          <custom-input
            v-model="model.websiteUrl"
            placeholder="www.websitedomain.com"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="telephone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">
              Teléfono:
            </label>
            <custom-input
              v-model="model.telephone"
              :custom-error-msg="'El teléfono es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              placeholder="(xxx)xxx-xxxx"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">
            Fax:
          </label>
          <validation-provider v-slot="{ errors }" name="fax" rules="phone">
            <custom-input
              v-model="model.fax"
              :custom-error-msg="'El fax no es valido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              placeholder="(xxx)xxx-xxxx"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';

export default {
  name: 'GeneralInformation',
  components: {
    ValidationProvider,
    SectionTitle,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isSomePhoneFilledUp() {
      const telephone = Boolean(this.model.telephone);
      const fax = Boolean(this.model.fax);
      return fax || telephone;
    },
  },
};
</script>
